module.exports = __webpack_public_path__ + "63a7d78d42c33b94fc7b957524795cac.svg";